import { styled, Box } from '@material-ui/core'

export const ColorRoute = styled(Box)(
  ({ colorRoute }: { colorRoute: string }) => ({
    width: '12px',
    minHeight: '72px',
    backgroundColor: colorRoute,
  }),
)
